import React from "react";
import { PLANS } from "config/plans";

export const PLAN_COLORS = {
  free: "#6B7280",
  silver: "#9CA3AF",
  gold: "#C9A84C",
  platinum: "#6366F1",
};

/**
 * Reusable PlanBadge component shared between Desktop and Mobile headers.
 * Renders a colored pill indicating the user's current subscription plan.
 */
const PlanBadge = ({ plan }) => {
  const planKey = (plan || "free").toLowerCase();
  const planConfig = PLANS[planKey] || PLANS.free;
  const planColor = PLAN_COLORS[planKey] || PLAN_COLORS.free;

  return (
    <h6
      className="nav-item"
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
    >
      Plan:{" "}
      <span
        style={{
          display: "inline-block",
          padding: "2px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 700,
          letterSpacing: "0.04em",
          color: "#fff",
          background: planColor,
        }}
      >
        {planConfig.name}
      </span>
    </h6>
  );
};

export default PlanBadge;
export const getPlanColor = (plan) => {
  const planKey = (plan || "free").toLowerCase();
  return PLAN_COLORS[planKey] || PLAN_COLORS.free;
};
